import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-879b62c2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "splide__list" };
const _hoisted_2 = { class: "splide__slide" };
const _hoisted_3 = { class: "images__image" };
const _hoisted_4 = ["src", "alt"];
import Splide from '@splidejs/splide';
import { HoverCursor } from 'hover-cursor';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'image_carousel',
    props: ['d'],
    setup(__props) {
        const props = __props;
        const splider = ref();
        const randomClass = `splide__${Math.floor(Math.random() * 9000) + 1000}`;
        document.addEventListener('DOMContentLoaded', function () {
            const splide = new Splide(splider.value, {
                focus: 'center',
                type: 'loop',
                perPage: 1,
                pagination: false,
                width: '100%',
                autoWidth: true,
                drag: props.d.image_carousel_images.length > 1,
                autoplay: props.d.image_carousel_images.length > 1,
                arrows: false,
                interval: 3000,
                paginationDirection: 'ttb',
            }).mount();
            if (props.d.image_carousel_images.length > 1) {
                new HoverCursor({
                    containerQuery: `.${randomClass}`,
                    snapPosition: 'R',
                    icon: '/images/explore.svg',
                    toggledIcon: '/images/explore.svg',
                    customClass: 'cursor'
                });
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["images inner", { 'images__full-width': __props.d.width == 'full-width' }])
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass(["content", [{ 'container': __props.d.width !== 'full-width' }, { 'inner': __props.d.width == 'full-width' }]])
                }, [
                    _createElementVNode("div", {
                        ref_key: "splider",
                        ref: splider,
                        class: _normalizeClass(["splide", randomClass])
                    }, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["splide__track", [{ 'splide__track__no-aspect-ratio': __props.d.remove_aspect_ratio == 1 }]])
                        }, [
                            _createElementVNode("ul", _hoisted_1, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.d.image_carousel_images, (image, index) => {
                                    return (_openBlock(), _createElementBlock("li", _hoisted_2, [
                                        _createElementVNode("div", _hoisted_3, [
                                            _createElementVNode("img", {
                                                src: image.image,
                                                alt: image.alt ?? '',
                                                loading: "lazy"
                                            }, null, 8, _hoisted_4)
                                        ])
                                    ]));
                                }), 256))
                            ])
                        ], 2)
                    ], 512)
                ], 2)
            ], 2));
        };
    }
});
